"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Col = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
// eslint-disable-next-line
var react_1 = require("@emotion/react");
var Col = function (_a) {
    var children = _a.children, _b = _a.justifyContent, justifyContent = _b === void 0 ? 'normal' : _b, _c = _a.alignItems, alignItems = _c === void 0 ? 'normal' : _c;
    return (0, jsx_runtime_1.jsx)("div", __assign({ css: (0, react_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    justify-content: ", ";\n    align-items: ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    justify-content: ", ";\n    align-items: ", ";\n  "])), justifyContent, alignItems) }, { children: children }), void 0);
};
exports.Col = Col;
exports.default = exports.Col;
var templateObject_1;
